import { ModalContainer, SectionHeader } from "../../../components";
import { HookFormSelect, SubmitButton, TextInput } from "../../../hook-form";
import { formatAsCurrency, getCurrencySymbol } from "../../../utils";
import { ICreateTopUpFormViewProps } from "./CreateTopUpForm";

export const View = ({
  isModalOpen,
  closeModal,

  isLoadingBalances,
  balances,

  errors,
  handleSubmit,
  register,
}: ICreateTopUpFormViewProps) => {
  return (
    <form onSubmit={handleSubmit} className="top-up--form">
      <ModalContainer
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        modalHeader={
          <SectionHeader
            title="Top-Up Your Wallet"
            subtitle="Send money into your wallet for transfers, bill payments & customer refunds"
          />
        }
      >
        <div className="flex-container flex-break--small">
          <div className="flex-box">
            <HookFormSelect
              name="currency"
              label="Wallet (Currency To Top-up)"
              infoIconText={`
                The wallet to top-up eg your NGN - Wallet, USD - Wallet.
                This depends on the currencies you have enabled.
                Note: If you have not setup for top-ups to be made in wallet currency, a conversion may be necessary for foreign currencies.`}
              showSkeleton={isLoadingBalances}
              selectItems={balances.map((bal) => ({
                text: `${bal.currency} - BALANCE: ${getCurrencySymbol(
                  bal.currency
                )}${formatAsCurrency(bal.available_wallet_balance)})`,
                value: bal.currency,
              }))}
              register={register}
              errors={errors}
            />
          </div>

          <div className="flex-box ml-md-5">
            <TextInput
              name="amount"
              label="Amount"
              infoIconText=""
              type="text"
              register={register}
              errors={errors}
            />
          </div>
        </div>

        <div className="flex-container submit-button--container">
          <SubmitButton
            // size="md"
            className="mt-5 flex-box"
            showChildrenWithLoadingIcon
          >
            Initiate TopUp
          </SubmitButton>
        </div>
      </ModalContainer>
    </form>
  );
};
